"use strict";

/**
 * @module Services.Metrics
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeasuredEntityClassMetrics = void 0;
/**
 * A snapshot of all metrics for a measured entity class.
 */
var MeasuredEntityClassMetrics = /** @class */function () {
  function MeasuredEntityClassMetrics(metricNames, values) {
    this.metricNames = metricNames;
    this.values = values;
  }
  return MeasuredEntityClassMetrics;
}();
exports.MeasuredEntityClassMetrics = MeasuredEntityClassMetrics;